import { ReactNode } from 'react';
import { ExtraInfoTable } from '../ExtraInfoTable/ExtraInfoTable';
import { type PrescriptionLink } from '../PrescriptionLinkList/PrescriptionLinkList';
import { buildGeneralInfoTableData } from './buildGeneralInfoTableData';

export type GeneralInfoTableProps = {
  // First and last name
  patientName: string | null;
  // First and last name
  prescriberName: string | null;
  // Unformatted datestring
  dob: string | null;
  // Unformatted datestring
  prescribedOn: string | null;
  drugName: string | null;
  prescriptionId: string | null;
  // Whether to show the drug name as a link to the Rx page. Defaults to true.
  linkDrugToRxPage?: boolean;
  relatedPrescriptions?: PrescriptionLink[];
  // Anything else you want tacked on to the bottom of the table
  extraData?: Array<{ label: string; value: string | null | ReactNode }>;
  // Minimum width for the label column. Defaults to 120px.
  minFieldLabelWidth?: string;
};

/**
 * Table with patient and prescriber info for top of detail pages (rx page, task page, review pages)
 */
export const GeneralInfoTable = ({
  patientName,
  prescriberName,
  dob,
  prescribedOn,
  drugName,
  prescriptionId,
  linkDrugToRxPage = true,
  relatedPrescriptions = [],
  extraData = [],
  minFieldLabelWidth,
}: GeneralInfoTableProps) => {
  const data = buildGeneralInfoTableData({
    patientName,
    prescriberName,
    dob,
    prescribedOn,
    drugName,
    prescriptionId,
    linkDrugToRxPage,
    relatedPrescriptions,
    extraData,
  });

  return <ExtraInfoTable data={data} minFieldLabelWidth={minFieldLabelWidth} />;
};
